import { useRouter } from 'next/router';
import React from 'react';
import { ComponentType } from 'react';
import { fetchAdminClients } from '../../api';
import { useAuth } from '../../context';

const withClient = (Component: ComponentType): ComponentType => (
  props: Record<string, string>,
): JSX.Element => {
  const { client, setClient, user } = useAuth();
  const router = useRouter();
  const { clientId: idFromQuery } = router.query;

  const clientFromQuery = parseInt(idFromQuery as string);

  if (clientFromQuery && !client) {
    const getAndSetClient = async (): Promise<void> => {
      if (user.isMultiClientUser) {
        // get client options
        const clientOptions = await fetchAdminClients();
        // match client with clientFromQuery
        const adminSelectedClient = clientOptions.find(
          (client) => client.id === clientFromQuery,
        );

        setClient({
          clientId: clientFromQuery,
          companyName: adminSelectedClient.companyName,
        });
      } else {
        setClient({
          clientId: clientFromQuery,
          companyName: user.companyName,
        });
      }
    };

    getAndSetClient();
  }

  if ((!client || !client.clientId) && !clientFromQuery) {
    router.push('/');
    return null;
  }

  return <Component {...props} />;
};

export default withClient;
